import React from 'react';
import { Link } from 'react-router-dom';
import { Download, Cpu, MonitorSmartphone, Usb, ArrowRight } from 'lucide-react';

const items = [
  { icon: Cpu, label: 'Firmwares WING' },
  { icon: MonitorSmartphone, label: 'WING EDIT & Apps' },
  { icon: Usb, label: 'Drivers USB' },
];

const DownloadsBanner = () => {
  return (
    <section className="bg-black py-16 md:py-20 px-4" data-testid="downloads-banner">
      <div className="max-w-6xl mx-auto">
        <div className="relative overflow-hidden rounded-2xl border border-yellow-500/30 bg-gradient-to-br from-gray-900 via-gray-900 to-black p-8 md:p-12">
          {/* Glow decorativo */}
          <div className="absolute -top-24 -right-24 w-64 h-64 bg-yellow-500/10 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-yellow-500/5 rounded-full blur-3xl pointer-events-none" />

          <div className="relative flex flex-col lg:flex-row items-start lg:items-center gap-8">
            <div className="flex-1">
              <span className="inline-flex items-center gap-2 bg-yellow-500/15 border border-yellow-500/40 text-yellow-400 text-xs font-bold tracking-widest uppercase px-4 py-1.5 rounded-full mb-4">
                <Download className="w-3.5 h-3.5" />
                Acesso Gratuito
              </span>
              <h2 className="text-2xl md:text-3xl font-black text-white mb-3">
                Central de <span className="text-yellow-400">Downloads</span> WING
              </h2>
              <p className="text-gray-400 text-sm md:text-base max-w-xl mb-6">
                Baixe firmwares oficiais, o WING EDIT para Windows e macOS, drivers USB e apps
                mobile — tudo organizado e atualizado em um só lugar, de graça.
              </p>
              <div className="flex flex-wrap gap-3">
                {items.map(({ icon: Icon, label }) => (
                  <span
                    key={label}
                    className="inline-flex items-center gap-2 bg-white/5 border border-white/10 text-gray-300 text-xs md:text-sm px-3 py-1.5 rounded-lg"
                  >
                    <Icon className="w-4 h-4 text-yellow-400" />
                    {label}
                  </span>
                ))}
              </div>
            </div>

            <div className="w-full lg:w-auto">
              <Link
                to="/downloads"
                data-testid="downloads-banner-cta"
                className="group inline-flex w-full lg:w-auto items-center justify-center gap-3 bg-yellow-500 hover:bg-yellow-400 text-black font-black text-sm md:text-base uppercase tracking-wide px-8 py-4 rounded-xl transition-colors"
              >
                <Download className="w-5 h-5" />
                Acessar Downloads
                <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
              </Link>
              <p className="text-gray-500 text-xs text-center lg:text-left mt-3">
                Sem cadastro • Links oficiais Behringer
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadsBanner;
